import React, { useState } from "react";
import { TOOLTIPS, TooltipKey } from "../data/tooltips";

interface HelpTooltipProps {
  tipKey: TooltipKey;
  position?: "top" | "bottom" | "left" | "right";
  iconSize?: "sm" | "md" | "lg";
  className?: string;
  iconColor?: string;
}

const POSITION_CLASSES = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "top-1/2 right-full -translate-y-1/2 mr-2",
  right: "top-1/2 left-full -translate-y-1/2 ml-2",
};

const ICON_SIZES = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
};

export const HelpTooltip: React.FC<HelpTooltipProps> = ({
  tipKey,
  position = "top",
  iconSize = "md",
  iconColor = "text-green-500",
  className = "",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={`relative inline-flex z-index-[99] ${className}`}>
      <button
        type="button"
        className={`${ICON_SIZES[iconSize]} ${iconColor} text-gray-400 bg-color-red hover:text-gray-600 transition-colors focus:outline-none`}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        aria-label="Help"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </button>

      <div
        className={`helpToolTip absolute z-[9999] w-max max-w-xs px-3 py-2 text-sm text-white bg-gray-800 rounded-md shadow-lg transition-opacity duration-150 ${
          POSITION_CLASSES[position]
        } ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        role="tooltip"
        dangerouslySetInnerHTML={{
          __html: TOOLTIPS[tipKey] as string,
        }}
      />
    </div>
  );
};